/* eslint-disable */
export const secondsToTime = (e) => {
	const h = Math.floor(e / 3600).toString().padStart(2, '0');
	const m = Math.floor(e % 3600 / 60).toString().padStart(2, '0');
	const s = Math.floor(e % 60).toString().padStart(2, '0');

	const result = `${h}:${m}:${s}`;

	if (result.split(':').length === 3 && result.split(':')[0].includes('00')) {
		return `${m}:${s}`;
	}

	return `${h}:${m}:${s}`;
};

export const getTimeInTimeZone = (timeZoneOffset) => {
	// Получаем текущее время
	const currentTime = new Date();

	// Получаем временную разницу относительно UTC в минутах
	const utcOffset = currentTime.getTimezoneOffset();

	// Вычисляем смещение времени в миллисекундах
	const timeZoneOffsetMs = timeZoneOffset * 60 * 60 * 1000;

	// Вычисляем разницу между временным поясом пользователя и требуемым временным поясом
	const timeDifferenceMs = utcOffset * 60 * 1000 + timeZoneOffsetMs;

	// Получаем новое время, добавляя временную разницу
	return new Date(currentTime.getTime() + timeDifferenceMs);
}
// Пример использования функции для получения времени в часовом поясе +5
//const currentTimeInTimeZone = getTimeInTimeZone(5);

export const dateTimeFilter = (value) => {
	let formateDate = new Date(value);
	let nowDay = formateDate.getDate(),
		nowMonth = formateDate.getMonth() + 1,
		nowYear = formateDate.getFullYear(),
		nowHour = formateDate.getHours(),
		nowMinute = formateDate.getMinutes(),
		nowSecond = formateDate.getSeconds();

	if (nowDay < 10) {
		nowDay = "0" + nowDay;
	}

	if (nowMonth < 10) {
		nowMonth = "0" + nowMonth;
	}

	if (nowHour < 10) nowHour = "0" + nowHour;
	if (nowMinute < 10) nowMinute = "0" + nowMinute;
	if (nowSecond < 10) nowSecond = "0" + nowSecond;

	return nowDay + "." + nowMonth + "." + nowYear + " " + nowHour + ":" + nowMinute + ":" + nowSecond;
}


